import { video } from './video';
import { heading } from './heading';
import { images } from './images';
import { dfl } from './dfl';

jQuery(document).ready(function($) {
	// Remove no-js class and replace with js.
	$('html').addClass('js').removeClass('no-js');

	video.init();
	heading.init();
	images.init();
	dfl.init();
});